import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout';
import ExternalHome from './views/ExternalHome';
import HomePage from './views/HomePage';
import DiagnosticToolPage from './views/DiagnosticToolPage';
import AboutPage from './views/AboutPage';
import AboutUsPage from './views/AboutUsPage';
import ExpertHomePage from './views/expertHome';
import { AuthProvider, useAuth } from './context/AuthContext';
import SymptomsPage from './views/SymptomsPage';
import AdvicePage from './views/AdvicePage';
import { LanguageProvider } from './context/LanguageContext';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import PrivacyPolicyPage from "./views/PrivacyPolicyPage";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return <div>Loading...</div>; // wait for cookie check
  if (!isAuthenticated) return <Navigate to="/sign-in" />;
  return children;
};


function AppRoutes() {
  return (
    <LanguageProvider>
    <Router>
      <Routes>       
         <Route path="/" element={<MainLayout />}>
          <Route index element={<ExternalHome />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/crops/:cid/disease" element={<DiagnosticToolPage />} />
          <Route path="/crops/:cid/disease/:disId/advice" element={<AdvicePage />} />
          <Route path="/crops/:cid/symptoms" element={<SymptomsPage />} />
          <Route path="/crops/:cid/symptom/level/:level" element={<SymptomsPage />} />
          {/* <Route path="disease-finder/:disId" element={<DiseaseFinderPage />} /> */}
          <Route path="about" element={<AboutPage />} />
          <Route path="about-us" element={<AboutUsPage />} />
          <Route path="privacy-policy" element={<PrivacyPolicyPage />} />          
          {/* <Route path="sign-in" element={<LoginPage />} /> */}
          <Route
            path="/expert-home"
            element={
              // <ProtectedRoute>
                <ExpertHomePage />
              // </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </Router>
    </LanguageProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <I18nextProvider i18n={i18n}>
        <AppRoutes />
      </I18nextProvider>
    </AuthProvider>
  );
}

export default App;